var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 200,
    width: 50,
    height: 500,
    fill: "#32A5B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 300,
    width: 50,
    height: 400,
    fill: "#2B8A9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 250,
    width: 50,
    height: 450,
    fill: "#0D5563"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.4ebace908dbb62e4ce0ad36168f3138c.svg";
export { ForwardRef as ReactComponent };